let html = `<div class="register layer--render layer--visible">
    <div class="register__name"></div>
    <div class="register__counter"></div>
</div>`

export default html